import React from 'react';
import {
  PageHeader,
  PageHeaderNavigation
} from 'components/clarity-ui';

/**
 * Site Navigation Layout.
 */
class EntityRecommenderPageHeader extends React.Component {

  renderPageHeaderNavigationLinks () {
    const navigationLinks = [];
    navigationLinks.push(this.props.title);
    return navigationLinks;
  }

  /**
  * Render the component
  *
  * @return {JSX} JSX component markup.
  **/
  render () {
    const { subhead, title } = this.props;
    return (
      <PageHeader title={title} subhead={subhead}>
        <PageHeaderNavigation>
          { this.renderPageHeaderNavigationLinks() }
        </PageHeaderNavigation>
      </PageHeader>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the Icon component
 */
EntityRecommenderPageHeader.propTypes = {
};

export default EntityRecommenderPageHeader;



// WEBPACK FOOTER //
// ./src/components/entityRecommender/entityRecommenderPageHeader.component.jsx